import { FaCheck, FaBookOpen, FaLightbulb, FaBalanceScale, FaFlag, FaListAlt, FaBook, FaArrowRight, FaRocket } from 'react-icons/fa';
import { HiSparkles } from 'react-icons/hi';
import { BsStarFill, BsCheckCircleFill } from 'react-icons/bs';

function AuthorIntroSection() {
  const specialFeatures = [
    { icon: FaCheck, text: "Real Experience:", desc: "Coaching 6,500+ businesses with proven results" },
    { icon: FaCheck, text: "Proven Methods:", desc: "₹3+ Crores recovered by participants in recent months" },
    { icon: FaBalanceScale, text: "Legal + Practical:", desc: "Both legal frameworks and street-smart tactics" },
    { icon: FaFlag, text: "Indian Context:", desc: "Specifically designed for Indian business environment" },
    { icon: FaListAlt, text: "Step-by-Step:", desc: "Actionable processes you can implement TODAY" },
    { icon: FaBook, text: "Complete Guide:", desc: "From prevention to recovery, everything covered" },
  ];

  return (
    <section className="relative overflow-hidden bg-white rounded-3xl p-8 sm:p-12 mb-10 shadow-xl border border-gray-100">
      {/* Background Decorations */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-blue-100/50 to-indigo-100/50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-gradient-to-tr from-purple-100/50 to-violet-100/50 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
      
      <div className="relative z-10 max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl mb-4 shadow-lg shadow-blue-500/30">
            <FaBookOpen className="text-3xl text-white" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            📖 A Word From The Author
          </h2>
        </div>
        
        {/* Letter Content */}
        <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-2xl p-6 sm:p-8 border border-gray-100 mb-8">
          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            <strong className="text-gray-900">Dear Business Owner,</strong>
          </p>
          
          <p className="text-gray-700 text-lg leading-relaxed mb-6">
            You are doing business in India for so long but facing one BIG challenge - you are not getting your <strong className="text-red-600">"Payments On Time"</strong>. Your pockets are empty because payments are not coming on time. When you sell products, clients talk nicely and promise timely payments, but once the product is dispatched, they don't pay on time.
          </p>
          
          <p className="text-gray-700 text-lg leading-relaxed">
            I understand your pain because <strong className="text-blue-600">I've been there!</strong> I've been coaching on this subject for 2.5+ years now and have done business for 19 years. But more importantly, I <strong className="text-green-600">LEARNED</strong> what works and what doesn't in Indian business context.
          </p>
        </div>
        
        {/* What Makes This Book Special */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 sm:p-8 border border-blue-100 mb-8">
          <h3 className="text-xl font-bold text-blue-700 mb-6 flex items-center gap-2">
            <HiSparkles className="text-amber-500" />
            What Makes This Book Special?
          </h3>
          
          <div className="grid sm:grid-cols-2 gap-4">
            {specialFeatures.map((feature, index) => (
              <div 
                key={index}
                className="flex items-start gap-3 bg-white rounded-xl px-4 py-3 shadow-sm border border-blue-100 hover:shadow-md hover:border-blue-300 transition-all"
              >
                <div className="w-8 h-8 bg-gradient-to-br from-green-400 to-emerald-500 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                  <feature.icon className="text-white text-sm" />
                </div>
                <div>
                  <span className="text-gray-800 font-semibold">{feature.text}</span>
                  <span className="text-gray-600 text-sm"> {feature.desc}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* CTA Banner */}
        <div className="bg-gradient-to-r from-indigo-600 via-purple-600 to-violet-600 rounded-2xl p-8 text-center shadow-xl">
          <div className="flex items-center justify-center gap-2 mb-3">
            <FaRocket className="text-amber-400 text-2xl" />
            <h3 className="text-xl sm:text-2xl font-bold text-white">
              Your Business Will Transform After Reading This!
            </h3>
          </div>
          <p className="text-white/90 text-lg mb-6">
            These 23 principles have helped thousands recover their stuck payments. Now it's your turn!
          </p>
          
          <a 
            href="#principles" 
            className="inline-flex items-center gap-3 bg-white text-indigo-600 px-8 py-4 rounded-2xl font-bold hover:bg-indigo-50 transition-all shadow-lg group"
          >
            <BsCheckCircleFill className="text-xl" />
            Start Learning The 23 Principles
            <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}

export default AuthorIntroSection;
